import { Suspense } from 'react';
import { Outlet } from 'react-router';
import CasinoHeader from '../molecules/CasinoHeader';
import { GlobalStyles, Stack } from '@mui/material';
import { LoaderContainer } from '../atoms/LoaderContainer';
import { CASINO_HEADER_HEIGHT } from '../molecules/CasinoHeader';
import { usePromoCodeTracking } from '../../hooks/usePromoCodeTracking';
import { useVerifyEmailRedirect } from '../../hooks/useVerifyEmailRedirect';
import { dynamicViewportHeight } from '../../styles/mixins';
import { SKIN_CONFIGS } from '../../config/skinRegistry/configs';
import { useDrawerNavigationState } from '../../hooks/components';
import { useSkinConfigs } from '../../hooks/useSkinConfigs';
import useBreakpoints from '../../hooks/useBreakpoints';
import DrawerNavigation from '../molecules/sidebar/DrawerNavigation';
import MobileBottomNavShell from './MobileBottomNavShell';
import JackpotWinnerOverlay from '../organisms/jackpot/JackpotWinnerOverlay';
import { PRODUCT } from '../../types/enums';

const styles = {
  main: (mobileBottomNavInset: string) => ({
    ...dynamicViewportHeight(),
    boxSizing: 'border-box',
    pt: { xs: CASINO_HEADER_HEIGHT.xs + 'px', md: CASINO_HEADER_HEIGHT.md + 'px' },
    pb: { xs: mobileBottomNavInset, md: 0 },
    overflowX: 'hidden',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    '--header-height': { xs: `${CASINO_HEADER_HEIGHT.xs}px`, md: `${CASINO_HEADER_HEIGHT.md}px` },
  }),
};

const CasinoLayout = () => {
  usePromoCodeTracking();
  useVerifyEmailRedirect();

  const { isDrawerOpen, toggleDrawerVisibility } = useDrawerNavigationState();
  const { isMobile } = useBreakpoints();
  const { mobileBottomNavHeight = 0 } = useSkinConfigs(SKIN_CONFIGS);

  const mobileBottomNavInset = `${mobileBottomNavHeight}px`;

  return (
    <>
      <GlobalStyles
        styles={{
          ':root': {
            '--header-height': `${CASINO_HEADER_HEIGHT.xs}px`,
            '--mobile-bottom-nav-height': mobileBottomNavInset,
          },
        }}
      />
      <CasinoHeader />
      <JackpotWinnerOverlay product={PRODUCT.CASINO} />
      {isMobile && <DrawerNavigation isOpen={isDrawerOpen} toggleVisibility={toggleDrawerVisibility} />}
      <Stack component='main' sx={styles.main(mobileBottomNavInset)}>
        <Suspense fallback={<LoaderContainer />}>
          <Outlet />
        </Suspense>
      </Stack>
      <MobileBottomNavShell isDrawerOpen={isDrawerOpen} toggleDrawerVisibility={toggleDrawerVisibility} />
    </>
  );
};

export default CasinoLayout;
